import React from 'react';
import './Spinner.scss';

const Spinner = (props) => {
  return (
    <div className="spinner" {...props}>
      <div className="spinner_elem"></div>
    </div>
  );
};

export default Spinner;
